import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@pinnakl/core/environment';
import { AG_GRID_KEY_TOKEN } from '@pinnakl/shared/constants';

@Injectable({
  providedIn: 'root',
})
export class AgGridLicenseService {
  private readonly agGridKey = inject(AG_GRID_KEY_TOKEN);
  private readonly envService = inject(EnvironmentService);

  private ready?: Promise<void>;

  initialize(): Promise<void> {
    return (this.ready ??= this.setupExternalComponents());
  }

  whenReady(): Promise<void> {
    return this.initialize();
  }

  private async setupExternalComponents(): Promise<void> {
    const { AllEnterpriseModule, LicenseManager, ModuleRegistry, provideGlobalGridOptions, ValidationModule } =
      await import('ag-grid-enterprise');

    provideGlobalGridOptions({ theme: 'legacy' });
    ModuleRegistry.registerModules([AllEnterpriseModule, ...(this.envService.isProdEnv ? [] : [ValidationModule])]);
    LicenseManager.setLicenseKey(this.agGridKey);
  }
}
